import * as React from "react";
import { Box } from "../box";
import { AriaProgressBarProps, useProgressBar } from "react-aria";
import { Flex } from "../flex";
import { Text } from "../text";
import { cx } from "../../utils/dom";
import { Color } from "../../utils/theme";

interface ProgressProps
  extends AriaProgressBarProps,
    React.ComponentPropsWithoutRef<"div"> {
  height?: number;
  color?: Color;
}

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ height = 2, className, style, color = "gray", ...props }, ref) => {
    const { minValue = 0, maxValue = 100, value = 0, label } = props;
    const { progressBarProps, labelProps } = useProgressBar(props);
    const percent = ((value - minValue) / (maxValue - minValue)) * 100;
    const barWidth = `${percent}%`;

    return (
      <Flex
        data-color={color}
        style={style}
        className={cx([className, "progress-bar"])}
        stack
        {...progressBarProps}
      >
        {label && <Text {...labelProps}>{label}</Text>}
        <div
          className="progress-wrapper"
          style={{
            height,
            background: "var(--color-3)",
            position: "relative",
            borderRadius: 60,
            overflow: "hidden",
          }}
          ref={ref}
        >
          <Box
            position={"absolute"}
            className="progress"
            style={{
              left: 0,
              top: 0,
              height: "100%",
              width: barWidth,
              background: "var(--color-10)",
              transition: "all 0.3s ease",
            }}
          ></Box>
        </div>
      </Flex>
    );
  }
);

Progress.displayName = "Progress";
